import React from 'react';

const Kalender = () => {
    return (
        <>
            <h1>Kalender</h1>
        </>
    );
}

export default Kalender;